import { createSlice } from "@reduxjs/toolkit";

// Persist across refresh: read from localStorage. With nothing stored, a fresh login lands on
// Production — the mode issued batches run under — so the Execution lists show them (EXV-002).
// 2026-10-12 · Trial unless the person chose Production in this session: a fresh login starts
// on Trial (AuthLogin.bootstrapSession resets it); a page refresh keeps whatever was chosen.
const initialTestProd = localStorage.getItem("testProdView") || "test";

const testProdChangeSlice = createSlice({
  name: "testProdView",
  initialState: initialTestProd,
  reducers: {
    setChangeTestProd: (state, action) => {
      localStorage.setItem("testProdView", action.payload); // persist
      return action.payload;
    },
  },
});
export const { setChangeTestProd } = testProdChangeSlice.actions;
export default testProdChangeSlice.reducer;
